/**
 * @generated SignedSource<<935620e56f3e7e86f1ca073510363727>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ScrapDeleteInput = {
  id: string;
};
export type ScrapSourceScrapDeleteDialog_scrapDeleteMutation$variables = {
  input: ScrapDeleteInput;
};
export type ScrapSourceScrapDeleteDialog_scrapDeleteMutation$data = {
  readonly scrapDelete: {
    readonly id: string;
  };
};
export type ScrapSourceScrapDeleteDialog_scrapDeleteMutation = {
  response: ScrapSourceScrapDeleteDialog_scrapDeleteMutation$data;
  variables: ScrapSourceScrapDeleteDialog_scrapDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ScrapSourceScrapDeleteDialog_scrapDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Scrap",
        "kind": "LinkedField",
        "name": "scrapDelete",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ScrapSourceScrapDeleteDialog_scrapDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Scrap",
        "kind": "LinkedField",
        "name": "scrapDelete",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteRecord",
            "key": "",
            "kind": "ScalarHandle",
            "name": "id"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "aab6da50ee6535f59bd26478c71894ce",
    "id": null,
    "metadata": {},
    "name": "ScrapSourceScrapDeleteDialog_scrapDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation ScrapSourceScrapDeleteDialog_scrapDeleteMutation(\n  $input: ScrapDeleteInput!\n) {\n  scrapDelete(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "fd8495a853d6e6d506b4aea77a97d341";

export default node;
